var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      class: { "stack-trace": true, loading: _vm.loading },
      attrs: { "data-cy": "stack-trace" }
    },
    [
      _vm.stackTraceTimestamp
        ? _c("header", [
            _c("span", [
              _vm._v(
                "Stack trace at " + _vm._s(_vm.formattedStackTraceTimestamp)
              )
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "refresh",
                attrs: { href: "#" },
                on: { click: _vm.getStackTrace }
              },
              [_vm._v("Refresh")]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.stackTrace && _vm.stackTrace.payloads !== undefined
        ? _c("pre", { staticClass: "stack-trace-view" }, [
            _vm._v(_vm._s(_vm.stackTrace.payloads))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.stackTrace && _vm.stackTrace.error
        ? _c("span", { staticClass: "error" }, [
            _vm._v("\n    " + _vm._s(_vm.stackTrace.error) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isWorkerRunning
        ? _c(
            "span",
            { staticClass: "no-queries" },
            [
              _vm._v(
                "\n    There are no Workers currently listening to the Task List:\n    "
              ),
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "task-list",
                      params: {
                        clusterName: _vm.clusterName,
                        taskList: _vm.taskListName
                      }
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.taskListName) + "\n    ")]
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c19e25f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c19e25f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/routes/workflow/stack-trace.vue
// module id = 1732
// module chunks = 0